




























































































































































































































































































































































































































































































import {
  defineComponent, reactive, ref, Ref, computed,
} from '@vue/composition-api';
import _ from 'lodash';
import { useFormat, useRouter } from '@ideavivat/vivat-2';

import {
  getSubJobs,
  getSubJobsForInternalTab,
  updateSubJob,
  duplicateSubJob,
  massUpdateSubJob,
} from '@/api/index';
import allSubJobTableOption from '@/table/Job/SubJob/all';
import internalSubJobTableOption from '@/table/Job/SubJob/internal';
import outsourceSubJobTableOption from '@/table/Job/SubJob/outsource';
import waitingPurchaseSubJobTableOption from '@/table/Job/SubJob/waiting_purchase_order';
import hasPurchaseOrderSubJobTableOption from '@/table/Job/SubJob/has_purchase_order';
import qcSubJobTableOption from '@/table/Job/SubJob/qc';
import useSubJob from '@/use/useSubJob';
// import
import useAuth from '@/use/useAuth';
import useDownloadReport from '@/use/useDownloadReport';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonModalWithSubJobDuplicate from '@/components/Job/CommonModalWithSubJobDuplicate.vue';
import CommonModalWithSubJobUpload from '@/components/Job/CommonModalWithSubJobUpload.vue';
import CommonModalWithSubJobEditor from '@/components/Job/CommonModalWithSubJobEditor.vue';
import CommonModalWithSubJobStationUpdate from '@/components/Job/CommonModalWithSubJobStationUpdate.vue';
import CommonModalWithBrieflySubJobEditor from '@/components/Job/CommonModalWithBrieflySubJobEditor.vue';

const PanelWithSubJobTable = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonModalWithSubJobEditor,
    CommonModalWithSubJobDuplicate,
    CommonModalWithSubJobUpload,
    CommonModalWithSubJobStationUpdate,
    CommonModalWithBrieflySubJobEditor,
  },
  props: {
    jobId: {},
    job: {},
  },
  setup(props, { emit, root }) {
    const { route, router } = useRouter();
    const { hasPermission: checkPermissionHandler } = useAuth();
    const { subJobFilter } = useSubJob();
    const { getCSVReport, getReport } = useDownloadReport();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }
    const toDateTime = (date: string): string => useFormat.date(date).displayFullThaiDateTime();
    const refetchQuery = ref(false);
    const editSubJobModal = ref(null);
    const deleteSubJobModal = ref(null);
    const duplicateSubJobModal = ref(null);
    const uploadSubJobModal = ref(null);
    const pendingSearch = _.debounce(() => { refetchQuery.value = true; }, 600);
    const totalItems = ref(0);

    const filter = reactive({
      filterBomId: props.jobId,
      searchString: '',
      searchModuleNo: '',
      searchDrawingNo: '',
      searchMaterialCode: '',
      // status: 'PENDING',
      filterOutsource: undefined,
    });

    function handlerFetchData(queryData: any) {
      const { from, to } = queryData;
      totalItems.value = (to - from) + 1;
    }

    // async function deleteSingleSubJobAction(ctx: { id: number }) {
    //   await deleteMaterial(ctx.id);
    //   refetchQuery.value = true;
    // }
    async function updateSingleSubJobStatus(id: number, payload: { status?: string, processStatus?: string, [key: string]: any }) {
      await updateSubJob(id, payload);
      refetchQuery.value = true;
      emit('pendingRefetchQuery');
    }

    // When upload done, check is possible to create PR
    const requestToCreatePrModal = ref(null);
    function uploadSubJobDoneHandler(event: any) {
      (uploadSubJobModal.value as any).close();
      (requestToCreatePrModal.value as any).compose({
        action: 'บันทึก',
        entity: ' Sub Job ',
        body: 'ต้องการสร้างใบขอซื้อเลยหรือไม่ ?',
        data: event,
        primaryAction: 'สร้าง PR',
        secondaryAction: 'ปิดหน้าต่าง',
      });
      refetchQuery.value = true;
    }
    function navigateToCreatePurchaseRequest(ctx: any) {
      const search = ctx.data.map((elm: any) => elm.bom_item_id);
      navigateToCreatePurchaseRequestAction(search);
    }
    function navigateToCreatePurchaseRequestAction(search: number[], treat = false, routeName = 'PurchaseRequestCreateProductionWithBomId') {
      router.push({
        name: routeName,
        params: treat ? undefined : { bomId: route.value.params.id },
        query: {
          instantSearch: search,
          subType: treat ? 'TREATMENT' : undefined,
        },
      });
    }

    // Use subjob click row
    const subJobStatusUpdateModal = ref(null);
    function subJobTableClickRowHandler(row: any) {
      if (hasPermission('bom.items.station')) (subJobStatusUpdateModal.value as any).compose(row.item.id);
      else if (hasPermission('bom.items.manage')) (editSubJobModal.value as any).open(row.item.id);
    }

    // Use with select box
    const selectedItemId: Ref<number[]> = ref([]);
    function selectItem(id: number | string) {
      const hitIndex = selectedItemId.value.indexOf(parseInt(id as string, 10));
      if (selectedItemId.value.indexOf(parseInt(id as string, 10)) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(parseInt(id as string, 10));
    }
    // Use to mass update sub job status
    async function massUpdateStatus(payload: any) {
      await massUpdateSubJob({
        ids: selectedItemId.value,
        ...payload,
      });
      refetchQuery.value = true;
      selectedItemId.value = [];
      emit('pendingRefetchQuery');
    }

    const currentTab = ref('all');

    function tabChangeHandler(tabName: string) {
      currentTab.value = tabName;
      selectedItemId.value = [];
      pendingSearch();
    }

    function handleSelectAllItem($event: any[]) { selectedItemId.value = $event; }
    const selectedAll = computed(() => selectedItemId.value.length === totalItems.value);

    return {
      subJobFilter,
      getReport,
      getCSVReport,
      toDateTime,
      currentTab,
      hasPermission,

      selectedAll,
      totalItems,

      editSubJobModal,
      deleteSubJobModal,
      // deleteSubJobAction,
      updateSingleSubJobStatus,

      filter,
      pendingSearch,
      handlerFetchData,
      getSubJobs,
      getSubJobsForInternalTab,
      refetchQuery,

      allSubJobTableOption,
      internalSubJobTableOption,
      outsourceSubJobTableOption,
      waitingPurchaseSubJobTableOption,
      hasPurchaseOrderSubJobTableOption,
      qcSubJobTableOption,

      selectedItemId,
      selectItem,
      massUpdateStatus,

      duplicateSubJobModal,
      duplicateSubJob,

      uploadSubJobModal,
      requestToCreatePrModal,
      uploadSubJobDoneHandler,
      navigateToCreatePurchaseRequest,
      navigateToCreatePurchaseRequestAction,
      tabChangeHandler,

      subJobStatusUpdateModal,
      subJobTableClickRowHandler,

      handleSelectAllItem,
    };
  },
});

export default PanelWithSubJobTable;
